import * as React from 'react';
import { cn } from '@packages/utils';

/** Centered festival content container. Sits inside the festival Layout chrome. */
export function Container({
  max = 1080,
  className,
  children,
}: {
  max?: number;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div
      className={cn('mx-auto w-full px-5 py-10 sm:px-8 sm:py-12 md:px-14', className)}
      style={{ maxWidth: max }}>
      {children}
    </div>
  );
}

/** Festival section header — uppercase grotesk title over a 3px rule. */
export function SectionRule({
  children,
  accent = 'var(--ww-charcoal)',
  className,
}: {
  children: React.ReactNode;
  accent?: string;
  className?: string;
}) {
  return (
    <div
      className={cn('mb-6 flex items-baseline gap-3.5 pb-2', className)}
      style={{ borderBottom: `3px solid ${accent}` }}>
      <h2 className="font-sans text-xl font-bold uppercase tracking-[0.04em] text-ww-charcoal">
        {children}
      </h2>
    </div>
  );
}
